import { Injectable } from '@angular/core';

@Injectable()
export class OpsFeatures {

  codes: Codes = {
    DisableClaimQuote: 'VALUTRAX_DISABLE_MANUAL_CLAIM',
    StatementHistory: 'VALUTRAX_STATEMENT_HIST',
    PartSearch: 'VALUTRAX_PART_SEARCH',
    Settings: 'VALUTRAX_SETTINGS',
    ClaimDetailsV2: 'EDIT_VALUTRAX_CLAIM',
    RejectClaim: 'REJECT_CLAIM',
    EditClaim: 'EDIT_VALUTRAX_CLAIM',
  };
}

export interface Codes {
  DisableClaimQuote: string;
  StatementHistory: string;
  PartSearch: string;
  Settings: string;
  ClaimDetailsV2: string;
  RejectClaim: string;
  EditClaim: string;
}
